import React from "react";
import PropTypes from "prop-types";

function View(props, { locals }) {
  const {
    params: { token },
  } = locals;
  return (
    <div id="login-wrapper">
      <form method="POST" action="/actions/user/update-password" data-noreset>
        <img
          className="logo"
          src="/img/msb-logo-white.svg"
          alt="My Strength Book"
        />
        <input type="hidden" name="token" value={token} />

        <div className="Steps" data-step="3">
          <div className="step"></div>
          <div className="step"></div>
          <div className="step"></div>
          <div className="step"></div>
        </div>

        <div className="frame">
          <div className="head">
            <h1 className="alt">Create A Password</h1>
          </div>

          <div className="columns">
            <div className="column" data-col="1/1">
              <label htmlFor="password" className="label">
                Password <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="password"
                name="password"
                placeholder="Password"
              />
            </div>

            <div className="column" data-col="1/1">
              <label htmlFor="confirmPassword" className="label">
                Confirm password <span className="required-input">*</span>
              </label>
              <input
                className="text-input"
                required
                type="password"
                name="confirmPassword"
                placeholder="Confirm password"
              />
            </div>

            <div className="column" data-col="1/1">
              <button className="button-input full" type="submit">
                Save Password
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

View.contextTypes = { locals: PropTypes.object };

const Step2 = (app) => {
  app.get("/step2/:token", ({ res }) => (res.body = <View />));
};

export default Step2;
